import React, { Component } from 'react'
import { Table, DatePicker, Button, message, Modal, Input } from 'antd'
import moment from 'moment'
import {
  clickDownload,
  round,
  toServeTime,
  toUpServeTime,
} from '../../../../util/index'
import { serviceOfDay, voidService } from '../../../../api/employee'
const { RangePicker } = DatePicker

const nowDate = new Date()
nowDate.setMonth(nowDate.getMonth() - 1)
nowDate.setDate(1)
nowDate.setHours(0, 0, 0, 0)
const nextDate = new Date()
nextDate.setMonth(nowDate.getMonth() + 1, 0)
nextDate.setHours(0, 0, 0, 0)

export default class dayTable extends Component {
  state = {
    isloading: false,
    pickerValue: [
      moment(nowDate, 'YYYY-MM-DD'),
      moment(nextDate, 'YYYY-MM-DD'),
    ],
    hackValue: null,
    dates: [],
    list: [],
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = async () => {
    const sTime = moment(this.state.pickerValue[0])
    const eTime = moment(this.state.pickerValue[1])
    sTime.startOf('day')
    eTime.add(1, 'day')
    eTime.startOf('date')
    const { status, detail, data } = await serviceOfDay({
      startTimestamp: sTime.unix(),
      endTimestamp: eTime.unix(),
    })
    this.setState({
      isloading: false,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
        const newData = dataAry.map((item) => {
            const {member, employee, service} = item
            const hour = Math.floor((service.duration) / 3600)
            const minute=Math.floor(service.duration % 3600 / 60)
            return {
                employeeId: employee.id, // 员工id
                name: employee.name, // 员工名称
                account: member ? member.account : '', // 用户
                serviceId: service.id, // 服务ID
                createTime: moment(service.startTime).format('YYYY-MM-DD'), // 日期
                identityType: service.identityType > 1 ? '记分员' : '助教', // 服务（身份）
                serviceDuration: `${moment(service.startTime).format(
                    'HH:mm'
                )}-${moment(service.endTime).format('HH:mm')}`, // 时间
                duration: `${hour}小时${minute}分钟`, // 时长
                serviceAmount: round(service.amount / 100, 2), // 服务费
                commission: round(service.commission / 100, 2), // 分成
            }
      })
      this.setState({
        list: newData,
      })
    } else {
      this.setState({
        list: [],
      })
    }
  }

  onChange = (value, dateString) => {
    if (!value) {
      return
    }
    this.setState({
      pickerValue: value,
    })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({
        dates: [],
        hackValue: [],
      })
    } else {
      this.setState({
        hackValue: undefined,
      })
    }
  }

  onCalendarChange = (val) => {
    this.setState({
      dates: val,
    })
  }

  disabledDate = (current) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false || current >= moment()
    }
    // 控制选择范围在30天内
    const tooLate =
      this.state.dates[0] && current.diff(this.state.dates[0], 'days') > 30
    const tooEarly =
      this.state.dates[0] && this.state.dates[0].diff(current, 'days') > 30
    return tooLate || tooEarly || current >= moment()
  }

  onSearchEvent = () => {
    if (this.state.isloading) {
      return
    }
    this.setState({ isloading: true }, this.getDatas)
  }

  showVoidModal = (record) => {
    let voidReason = ''
    Modal.confirm({
      title: '作废确认',
      content: (
        <div>
          <p>作废后，该条记录将不计入助教提成，是否确认作废？</p>
          <Input.TextArea
            rows={3}
            placeholder="请输入作废原因（必填）"
            maxLength={30}
            onChange={(e) => { voidReason = e.target.value }}
          />
        </div>
      ),
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        if (!voidReason.trim()) {
          message.error('作废原因不能为空')
          return Promise.reject()
        }
        const { status, detail } = await voidService({
          serviceId: record.serviceId,
          reason: voidReason.trim(),
        })
        if (status != 1) {
          message.error(detail || '作废失败')
          return
        }
        message.success('作废成功')
        this.getDatas()
      },
    })
  }

  render() {
    const { isloading, list, hackValue, pickerValue } = this.state
    const dateString = pickerValue
      ? `${pickerValue[0].format('YYYY-MM-DD')}-${pickerValue[1].format(
          'YYYY-MM-DD'
        )}`
      : moment().format('YYYY-MM-DD')
    const columns = [
      {
        title: '日期',
        dataIndex: 'createTime',
      },
      {
        title: '用户',
        dataIndex: 'account',
      },
      {
        title: '服务员',
        dataIndex: 'name',
      },
      {
        title: '服务',
        dataIndex: 'identityType',
      },
      {
        title: '时间',
        dataIndex: 'serviceDuration',
      },
      {
        title: '时长',
        dataIndex: 'duration',
      },
      {
        title: '服务费(元)',
        dataIndex: 'serviceAmount',
      },
      {
        title: '分成(元)',
        dataIndex: 'commission',
      },
      {
        title: '操作',
        render: (_, record) => (
            <div style={{color: "red", cursor: "pointer"}} onClick={() => this.showVoidModal(record)}>作废</div>
        ),
      },
    ]
    return (
      <div>
        <div className="csr-table-select-top-view">
          <RangePicker
            disabledDate={this.disabledDate}
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={hackValue || pickerValue}
            onChange={this.onChange}
            onCalendarChange={this.onCalendarChange}
            onOpenChange={this.onOpenChange}
          />
          <Button
            type="primary"
            className="csr-button-flex-left"
            onClick={this.onSearchEvent}
          >
            查询
          </Button>
          <Button type="default" className="csr-button-flex-left">
            <a
              id="test"
              href={clickDownload(columns.filter(c => c.title !== '操作'), list || [])}
              download={`服务记录按日查看-${dateString}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <Table
          rowKey="serviceId"
          loading={isloading}
          bordered
          size="small"
          columns={columns}
          dataSource={list}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubServiceRecord/component/dayTable/dayTable.js